// V2 playful fallback data used only for non-critical guest/profile placeholders.

export const MOCK_BADGES = [
  { emoji: '🌅', label: 'ตื่นเช้า',  threshold: 0 },
  { emoji: '🦴', label: 'นักสำรวจ', threshold: 0 },
  { emoji: '🤝', label: 'ผู้ช่วย',   threshold: 3 },
  { emoji: '🎉', label: '7 วัน',     threshold: 7 },
  { emoji: '👑', label: '30 วัน',    threshold: 30 },
  { emoji: '⭐', label: '100 วัน',   threshold: 100 },
];

// Rotating "did you know?" facts to keep the home page feeling alive & playful
export const MOCK_TRIVIA = [
  { emoji: '🐕', text: 'หมาจำชื่อของได้ถึง 250 คำ — เก่งกว่าเด็ก 2 ขวบนิดเดียว' },
  { emoji: '🐈', text: 'แมวกระโดดได้สูงกว่าตัว 6 เท่า ไม่ต้องวอร์มเลยด้วย' },
  { emoji: '🐾', text: 'รอยจมูกของหมาแต่ละตัวไม่ซ้ำกัน เหมือนลายนิ้วมือคน' },
  { emoji: '😼', text: 'เสียงครางของแมว 25–150 Hz ช่วยลด stress มนุษย์ได้' },
  { emoji: '🦴', text: 'หมาดมกลิ่นเก่งกว่าคน 10,000–100,000 เท่า' },
  { emoji: '👃', text: 'หมาสูดลมหายใจเข้า-ออก พร้อมกันได้ คนทำไม่ได้' },
  { emoji: '🌙', text: 'แมวนอนวันละ 12–16 ชม. ใช้พลังเวลาตื่นเต็มที่ทุกวินาที' },
  { emoji: '👂', text: 'หมาฟังเสียงได้ไกลกว่าคน 4 เท่า ความถี่ก็สูงกว่ามาก' },
  { emoji: '🐶', text: 'หมาเข้าใจภาษากายมนุษย์ดีกว่าลิงชิมแปนซีอีก' },
  { emoji: '🐱', text: 'แมวมีระยะการมองในที่มืดดีกว่าคน 6 เท่า' },
  { emoji: '❤️', text: 'หัวใจหมาเต้น 100–140 ครั้ง/นาที เร็วกว่าคน ~70%' },
  { emoji: '👅', text: 'แมวมีปุ่มลิ้นเล็กๆ ใช้ "หวี" ขนตัวเอง — เหมือนมีหวีในปาก' },
  { emoji: '🎨', text: 'หมาไม่ได้มองเห็นเป็นขาวดำ มีสีน้ำเงิน-เหลือง-เทา' },
  { emoji: '😸', text: 'แมวยิ้ม "หรี่ตา" ช้าๆ = บอกว่า "รักนะ" ในภาษาแมว' },
  { emoji: '🌧️', text: 'หมาบางพันธุ์ดมหากลิ่นโรคของคนได้ (มะเร็ง · เบาหวาน)' },
  { emoji: '🪞', text: 'แมว 6 เดือนขึ้นไป มักไม่รู้ตัวว่าในกระจกคือตัวเอง' },
  { emoji: '💧', text: 'หมาเหงื่อออกที่ฝ่าเท้า ไม่ออกตามตัวเหมือนคน' },
  { emoji: '⏰', text: 'แมวรู้เวลาให้อาหารแม่นกว่านาฬิกาในบ้านอีก!' },
];
